import { styled } from '@/src/stitches.config'
import React from 'react'
import { FedexCheckInput } from '@/dto/fedexCheck.input'

export const FieldWrapper = styled('div', {
    my: 15,
    '.shipping-button': {
        margin: 'auto',
        width: '100%',
        mt: 10,
    },
    // @todo make select display options more responsive when values are longer
    // '.select-content': {
    // },
})

export const SelectError = styled('p', {
    color: '$error',
    fontSize: '.9rem',
    mt: 10,
    mb: 0,
    ml: 10,
})

export const AddressSuggestionsList = styled('div', {
    mt: 2,
    br: 8,
    border: '2px solid $primary',
    position: 'absolute',
    top: '100%',
    bc: 'white',
    zIndex: 999,
})

export const AddressSuggestionListItem = styled('div', {
    m: 10,
    cursor: 'pointer',
})

export const formattedAddressDisplay = ({
    addressLine1,
    addressLine2,
    city,
    stateAbbreviation,
    zipCode,
}: FedexCheckInput) => {
    return (
        <span>
            {addressLine1}
            <br />
            {addressLine2 && (
                <>
                    {addressLine2}
                    <br />
                </>
            )}
            {city}
            <br />
            {stateAbbreviation}
            <br />
            {zipCode}
        </span>
    )
}

export const AddressDisplayWrapper = styled('div', {
    br: 8,
    border: '2px solid $darkest',
    background: '$white',
    p: 12,
    '>p ': {
        mt: 0,
        textDecoration: 'underline',
        fontWeight: 700,
        fontSize: '1.1em',
    },
})
